// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import chevronDownIcon from "@/assets/icons/chevron-down.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ChevronDownIconProps = Omit<IconProps, "name">;

export function ChevronDownIcon(props: ChevronDownIconProps): React.ReactNode {
  return <Icon name={chevronDownIcon} {...props} />;
}
